export const stringifyCoolblueEmployee = (employee) => {
    return JSON.stringify(employee);
};
export const parseCoolblueEmployee = (employee) => {
    if (!employee) {
        return null;
    }
    try {
        return JSON.parse(employee);
    }
    catch (e) {
        return null;
    }
};
//# sourceMappingURL=coolblueEmployee.js.map